import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment-timezone";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Box, CircularProgress,  Typography, Avatar, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import momenttimezone from "moment-timezone";
import CreateMeetings from "./CreateMeetings";
import { getPatients } from "../../api/patient";
import { decryptPatientData } from "../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { decryptData } from "../../utils/helper";
import { getAllMeetings } from "../../api/meetings";
import { failed } from "../../utils/Tostify";
import { getStaffsByOrgId } from "../../api/User";

const localizer = momentLocalizer(moment);

export default function EventTimelineList({setSelectedMeeting,currentDate,setCurrentDate,events,setEvents,getDateWiseMeetings}) {
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [patientList, setPatientList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const userTimeZone = momenttimezone.tz.guess(); // Get user's timezone dynamically
  const dispatch = useDispatch();
  let token = useSelector(state => state.userReducer.token);

  // Fetch events when date changes
  useEffect(() => {
    getDateWiseMeetings(currentDate);
  }, [currentDate]);

  // Update calendar events when `events` change
  useEffect(() => {
    setCalendarEvents(
      events.map((event) => ({
        id: event._id,
        title: event.eventTitle,
        start: momenttimezone.tz(event.fromTime, "UTC").tz(userTimeZone).toDate(),
        end:  momenttimezone.tz(event.toTime, "UTC").tz(userTimeZone).toDate(),
        teamMembers: event.teamMembers
      }))
    );
  }, [events]);

  const handleEventClick = (event) => {
    const selectedEvent = events.find((e) => e._id === event.id);
    if (selectedEvent) {
      setSelectedMeeting(selectedEvent);
    }
  };

  // Get week dates
  const getWeekDates = () => {
    const startOfWeek = moment(currentDate).startOf("week");
    return Array.from({ length: 7 }, (_, i) => startOfWeek.clone().add(i, "days"));
  };

  const getPatientList = async () => {
      let res;
      try {
        res = await getPatients({ dispatch, token, listFilter:"all", orgId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId") });
        if (res?.status === "SUCCESS") {
          const responseData = decryptData(res.data);
          if (responseData?.list) {
            const decryptedPatients = await Promise.all(
              responseData.list.map(async (patient) => {
                return decryptPatientData(patient);
              })
            );
            setPatientList(decryptedPatients.map((obj) => ({
              label: obj?.name?.text,
              value: obj?._id
            })));
          }
        }
      } catch (error) {
        // failed(res?.message);
      }
    };

   const getMeetings = async () => {
     let res;
     try {
       setIsLoading(true);
       const localDate = moment(selectedDate).tz(userTimeZone).startOf("day").utc();
       const values = {
         orgId: localStorage.getItem("currentOrgId"),
         clinicId: localStorage.getItem("currentHospitalId"),
         date:localDate
       };
       res = await getAllMeetings({ values, dispatch, token });
       const responseData = decryptData(res?.data);
       if (res?.status === "SUCCESS") {
         const userTimeZone = momenttimezone.tz.guess(); // Get user's timezone dynamically
         const formattedEvents = responseData.map((event) => {
           // Convert stored UTC date and time to user's timezone
           const startDate = momenttimezone.tz(event.fromTime, "UTC").tz(userTimeZone).toDate();
           const endDate = momenttimezone.tz(event.toTime, "UTC").tz(userTimeZone).toDate();
           return {
             id: event._id,
             title: event.eventTitle,
             start: startDate,  // Now in user's timezone
             end: endDate,      // Now in user's timezone
             description: event?.description,
             teamMembers: event?.teamMembers,
             patient: event?.patient,
             eventId: event?._id,
             createdBy: event?.createdBy
           };
         });
         setEvents(formattedEvents);
         setIsLoading(false);
       }else{
         setIsLoading(false);
       }
     } catch (error) {
       failed(res?.message);
       setIsLoading(false);
     }
   };

   const getUsersList = async (page = 1, limit = 10, searchKey = "") => {
       let res;
       try {
         res = await getStaffsByOrgId({dispatch, token, page, limit, searchKey, orgId: localStorage.getItem("currentOrgId"), currentHospitalId : localStorage.getItem("currentHospitalId")});
         const responseData = decryptData(res?.data);
         if (res?.status === "SUCCESS") {
           setTeamMembers(
             responseData?.items.filter((item) => item?.active !== false).map((obj) => ({
               label: obj?.firstName + " " + obj?.lastName,
               value: obj?._id
             }))
           );
         }
       } catch (error) {
         failed(res?.message);
       }
     };

     const handleUserSearch=(e, newInputValue, reason)=>{
      if(reason == "input"){
        getUsersList(1, 10, e.target.value);
      }
    };

    const handleRangechange=(e)=>{
      setSelectedDate(e[0]);
    };

    useEffect(() => {
        getUsersList();
        getPatientList();
      }, []);

  const handleSelectSlot  = (event) => {
    setSelectedEvent(event);
    setShowOffcanvas(true);
  };

  const CustomEvent = ({ event }) => {
    return (
      <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1 }}>
      {/* Avatars */}
      {event.teamMembers?.slice(0, 2).map((member) => (
        <Avatar
          key={member._id}
          src={member.avatar ? member.avatar : `https://i.pravatar.cc/50?u=${member._id}`}
          alt={member.name}
          sx={{ width: 24, height: 24 }}
        />
      ))}
      {event.teamMembers?.length > 2 && (
        <Avatar sx={{ width: 24, height: 24, bgcolor: "gray", fontSize: "0.8rem" }}>
          +{event.teamMembers.length - 2}
        </Avatar>
      )}
      {/* Event Title */}
      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
        {event.title}
      </Typography>
    </Box>
    <Typography variant="body2" sx={{ fontWeight: "bold",gap: 1.5, marginLeft:"40px" }}>
      Time : {moment(event.start).format("hh:mm A")} - {moment(event.end).format("hh:mm A")}
      </Typography>
    </>
    );
  };

  return (
       <Box>
  {/* Week Navigation Bar */}
  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mb: 2 }}>
    <IconButton onClick={() => setCurrentDate(moment(currentDate).subtract(1, "week").toDate())}>
      <ChevronLeft />
    </IconButton>

    {getWeekDates().map((date) => (
      <Typography
        key={date.format("YYYY-MM-DD")}
        sx={{
          cursor: "pointer",
          px: 1.5,
          py: 0.5,
          borderRadius: "20px",
          fontWeight: "bold",
          transition: "0.3s",
          bgcolor: date.isSame(moment(currentDate), "day") ? "#1976D2" : "transparent",
          color: date.isSame(moment(currentDate), "day") ? "white" : "black",
          "&:hover": { bgcolor: "rgba(25, 118, 210, 0.2)" }
        }}
        onClick={() => setCurrentDate(date.toDate())}
      >
        {date.format("ddd D")}
      </Typography>
    ))}

    <IconButton onClick={() => setCurrentDate(moment(currentDate).add(1, "week").toDate())}>
      <ChevronRight />
    </IconButton>
  </Box>

  {/* Loader */}
  {isLoading ? (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
      <CircularProgress />
    </Box>
  ) : (
    <div className="custom-calendar-container">
    <Calendar
    localizer={localizer}
    events={calendarEvents}
    startAccessor="start"
    endAccessor="end"
    style={{ height: 600, border: "none", boxShadow: "none", background: "transparent" }}
    views={["day"]}
    defaultView="day"
    scrollToTime={new Date()}
    date={currentDate}
    step={30} // Each slot represents 30 minutes
    timeslots={1} // Ensures 2 slots per hour (30 min each)
    onNavigate={(date) => setCurrentDate(date)}
    onSelectEvent={handleEventClick}
    components={{
      event: CustomEvent
    }}
    eventPropGetter={() => ({
      style: {
        backgroundColor: "#F4E8E6",
        color: "black",
        borderRadius: "4px",
        fontSize:"20px",
        padding: "4px",
        border: "none"
      }
    })}
    selectable
    onSelectSlot={(slotInfo) => {
      handleSelectSlot(slotInfo);
    }}
    onRangeChange={handleRangechange}
  />
  </div>
  )}
  {showOffcanvas && (
    <CreateMeetings
      show={showOffcanvas}
      selectedDate={selectedDate}
      onHide={() => setShowOffcanvas(false)}
      patients={patientList}
      getMeetings={getMeetings}
      getDateWiseMeetings={getDateWiseMeetings}
      currentDate={currentDate}
      teamMembers={teamMembers}
      selectedEvent={selectedEvent}
      isLoading={isLoading}
      handleUserSearch={handleUserSearch}
      setIsLoading={setIsLoading}
    />
  )}
</Box>
  );
}
